import { render, staticRenderFns } from "./UserForgotPassword.vue?vue&type=template&id=457c5d1c&"
import script from "./UserForgotPassword.vue?vue&type=script&lang=js&"
export * from "./UserForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457c5d1c')) {
      api.createRecord('457c5d1c', component.options)
    } else {
      api.reload('457c5d1c', component.options)
    }
    module.hot.accept("./UserForgotPassword.vue?vue&type=template&id=457c5d1c&", function () {
      api.rerender('457c5d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/UserForgotPassword.vue"
export default component.exports